import actions from './actions';

const initState = {
  isLoading: false,
  errorMessage: false,
  perguntas: {},
  modalActive: false,
  pergunta: {
    key: null,
    id: new Date().getTime(),
    pergunta: '',
    resposta: '',
    created_at: new Date().getTime(),
    deleted_at: null, // soft delete
  },
};

export default function reducer(
  state = initState,
  { type, payload, newRecord }
) {
  switch (type) {
    case actions.LOAD_FROM_FIRESTORE:
      return {
        ...state,
        isLoading: true,
        errorMessage: false,
        modalActive: false,
      };
    case actions.LOAD_FROM_FIRESTORE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        perguntas: payload.data,
        errorMessage: false,
      };
    case actions.LOAD_FROM_FIRESTORE_ERROR:
      return {
        ...state,
        isLoading: false,
        errorMessage: 'Houve um problema no carregamento',
      };
    case actions.TOGGLE_FIRESTORE_HANDLE_MODAL:
      return {
        ...state,
        modalActive: !state.modalActive,
        pergunta: payload.data == null ? initState.pergunta : payload.data,
      };
    case actions.FIRESTORE_UPDATE:
      return {
        ...state,
        pergunta: payload.data,
      };
    default:
      return state;
  }
}
